import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'gu',
    fullName: 'Gujarati',
    nativeName: 'ગુજરાતી',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "આર્ગવોઇડ",
    landing_title: "સમથિંગ અમેઝિંગ ઈઝ કમિંગ",
    landing_subtitle: "ArgVoid એ એક એપ્લિકેશન અને ગેમ ડેવલપમેન્ટ સ્ટુડિયો છે. ટ્યુન રહો, નવી વસ્તુઓ ટૂંક સમયમાં આવી રહી છે!",
    select_language: "ભાષા પસંદ કરો",
    search_placeholder: "ભાષાઓ શોધો...",
    terms_title: "સેવાની શરતો",
    policy_title: "ગોપનીયતા નીતિ",
    cookies_title: "કૂકી નીતિ",
    terms_content: `
        <strong>1. શરતો</strong><br>ની સ્વીકૃતિ
        ArgVoid ને ઍક્સેસ કરીને, આ સેવાની શરતો સ્વીકારવામાં આવે છે. જો આ શરતો સાથે સંમત ન હોય, તો સેવાનો ઉપયોગ થવો જોઈએ નહીં.<br><br>

        <strong>2. પ્લેટફોર્મ વપરાશ</strong><br>
        ArgVoid અને તેની એપ્લિકેશનો માહિતી અને સર્જનાત્મક હેતુઓ માટે "જેમ છે તેમ" પ્રદાન કરવામાં આવે છે. સેવાનો ઉપયોગ માત્ર કાયદેસરના હેતુઓ માટે જ થવો જોઈએ.<br><br>

        <strong>3. પ્રતિબંધિત આચાર</strong><br>
        સાઇટની નબળાઈઓ, સ્પામિંગ અથવા ઈન્ફ્રાસ્ટ્રક્ચરની અનધિકૃત ઍક્સેસનો પ્રયાસ સખત રીતે પ્રતિબંધિત છે.<br><br>

        <strong>4. ડિસ્ક્લેમર</strong><br>
        પ્લેટફોર્મ અને સેવાઓ કોઈપણ સમયે સૂચના વિના સંશોધિત થઈ શકે છે. અપટાઇમ અથવા સેવાની ઉપલબ્ધતા સંબંધિત કોઈ વોરંટી આપવામાં આવતી નથી.
    `,
    policy_content: `
        <strong>1. માહિતી સંગ્રહ</strong><br>
        પ્લેટફોર્મને આ સમયે વપરાશકર્તા પ્રમાણીકરણ અથવા એકાઉન્ટ બનાવવાની જરૂર નથી. મુલાકાતીઓ પાસેથી કોઈ વ્યક્તિગત ઓળખાણ માહિતી (જેમ કે નામ અથવા ઈમેલ એડ્રેસ) સક્રિયપણે એકત્રિત કરવામાં આવતી નથી.<br><br>

        <strong>2. વપરાશ ડેટા</strong><br>
        સાઇટ ટ્રાફિકને સમજવા અને એપ્લિકેશનને સુધારવા માટે મૂળભૂત, અનામી વિશ્લેષણ એકત્રિત કરવામાં આવી શકે છે. આ ડેટા વ્યક્તિગત વપરાશકર્તા ઓળખ સાથે જોડાયેલ નથી.<br><br>

        <strong>3. તૃતીય-પક્ષ સેવાઓ</strong><br>
        તૃતીય-પક્ષ પ્રદાતાઓનો ઉપયોગ હોસ્ટિંગ અને એનાલિટિક્સ સેવાઓ માટે થઈ શકે છે. આ સંબંધિત પ્રદાતાઓની ગોપનીયતા પ્રથાઓ તેમના ઇન્ફ્રાસ્ટ્રક્ચર પર પ્રક્રિયા કરાયેલા અનામી ડેટાને સંચાલિત કરે છે.<br><br>

        <strong>4. ડેટા સુરક્ષા</strong><br>
        પ્લેટફોર્મને સુરક્ષિત કરવા માટે વાજબી સુરક્ષા પગલાં લાગુ કરવામાં આવે છે. જો કે, ઈન્ટરનેટ પર ટ્રાન્સમિશનની કોઈપણ પદ્ધતિ સંપૂર્ણપણે સુરક્ષિત નથી.<br><br>
    `,
    cookies_content: `
        <strong>1. કૂકીઝ અને સ્થાનિક સ્ટોરેજ શું છે?</strong><br>
        કૂકીઝ અને બ્રાઉઝર સ્થાનિક સ્ટોરેજ એ બધી મુલાકાતોમાં ગોઠવણી પસંદગીઓને યાદ રાખવા માટે ઉપકરણ પર સંગ્રહિત નાની ડેટા ફાઇલો છે.<br><br>

        <strong>2. ઉપયોગ હેતુ</strong><br>
        બ્રાઉઝર લોકલસ્ટોરેજનો ઉપયોગ રૂપરેખાંકન સેટિંગ્સને સાચવવા માટે સખત રીતે થાય છે, જેમ કે:<br>
        - ભાષા પસંદગીઓ<br>
        - વપરાશકર્તા ઈન્ટરફેસ રૂપરેખાંકન (દા.ત., લેઆઉટ અથવા થીમ સેટિંગ્સ)<br>
        - અસ્થાયી એપ્લિકેશન cache<br><br>

        <strong>3. કોઈ Tracking</strong><br> નથી
        કૂકીઝ અને સ્થાનિક સ્ટોરેજનો ઉપયોગ જાહેરાત અથવા તૃતીય-પક્ષ ટ્રેકિંગ હેતુઓ માટે થતો નથી. તમામ સંગ્રહિત ડેટા પ્લેટફોર્મની મુખ્ય કાર્યક્ષમતા માટે સખત રીતે છે.<br><br>

        <strong>4. Control</strong><br>
        બ્રાઉઝર સેટિંગ્સ દ્વારા કોઈપણ સમયે બ્રાઉઝર ડેટા સાફ કરી શકાય છે, જે કોઈપણ સ્થાનિક ગોઠવણીને રીસેટ કરશે.
    `,
    cookie_consent_text: "વેબસાઈટ યોગ્ય રીતે કાર્ય કરે છે તેની ખાતરી કરવા માટે અમે મૂળભૂત કૂકીઝનો ઉપયોગ કરીએ છીએ, જેમ કે તમારું સત્ર સક્રિય રાખવું, તમારી ભાષાની પસંદગી સાચવવી અને અન્ય કસ્ટમ ગોઠવણીઓ.",
    read_policy: "કૂકી નીતિ વાંચો",
    support_title: "સપોર્ટનો સંપર્ક કરો",
    support_subject_label: "વિષય",
    support_message_label: "સંદેશ",
    support_submit_button: "સંદેશ મોકલો",
    support_hint: "નોંધ: આ સંદેશ મોકલવા માટે તમારી ડિફોલ્ટ ઇમેઇલ એપ્લિકેશન ખોલશે.",
    support_success_msg: "તમારી ઇમેઇલ ઍપ ખોલી રહ્યાં છીએ...",
    support_error_msg: "સંદેશ મોકલવામાં નિષ્ફળ. કૃપા કરીને પછીથી ફરી પ્રયાસ કરો.",
    explorer_title: "એક્સપ્લોરર",
    history_title: "ઈતિહાસ",
    animation_title: "એનિમેશન",
    config_title: "રૂપરેખાંકન",
    tool_mouse: "પસંદ કરો (Ctrl+M)",
    tool_brush: "બ્રશ (Ctrl+B)",
    tool_brush_mode: "ટૉગલ મોડ (સોલિડ/ક્લિયર)",
    tool_eraser: "ઇરેઝર (Ctrl+E)",
    tool_brush_size: "બ્રશનું કદ સમાયોજિત કરો",
    tool_bucket: "ભરો (Ctrl+F)",
    tool_eyedropper: "આઇડ્રોપર",
    tool_grid: "ગ્રીડ (Ctrl+Shift+B)",
    tool_rotate: "ફેરવો (Ctrl+Shift+R)",
    tool_flip_h: "ફ્લિપ H (Ctrl+Shift+H)",
    tool_flip_v: "ફ્લિપ V (Ctrl+Shift+V)",
    tool_transpose: "ટ્રાન્સપોઝ (Ctrl+Shift+T)",
    label_width: "પહોળાઈ",
    label_height: "ઊંચાઈ",
    label_frames: "ફ્રેમની સંખ્યા",
    label_animation: "એનિમેશન શૈલી",
    label_background_color: "પૃષ્ઠભૂમિ રંગ",
    label_interval: "અંતરાલ",
    tool_anim_config: "એનિમેશન રૂપરેખાંકન",
    label_new_width: "નવી પહોળાઈ",
    label_new_height: "નવી ઊંચાઈ",
    label_apply: "અરજી કરો",
    label_colors: "રંગો",
    label_size: "કદ",
    label_tolerance: "સહનશીલતા",
    val_horizontal: "આડી",
    val_vertical: "વર્ટિકલ",
    val_sequence: "ક્રમ",
    val_bounce: "બાઉન્સ",
    val_random: "રેન્ડમ",
    val_solid: "ઘન",
    val_clear: "સાફ કરો",
    action_add_sheet: "નવી શીટ",
    action_import: "આયાત કરો",
    action_export: "નિકાસ કરો",
    action_sort_projects: "સૉર્ટ કરો",
    sort_date_old: "સૌથી જૂની પ્રથમ",
    sort_date_new: "સૌથી નવું પ્રથમ",
    sort_name_az: "નામ (A-Z)",
    sort_name_za: "નામ (Z-A)",
    action_new_sprite: "નવી સ્પ્રાઈટ",
    action_new_project: "નવો પ્રોજેક્ટ",
    modal_save_all_title: "બધા ફેરફારો સાચવો",
    modal_save_all_desc: "સાચવવા માટે સંપત્તિ પસંદ કરો:",
    modal_save_selected: "પસંદ કરેલ સાચવો",
    action_saved: "સાચવેલ",
    modal_create_sprite_title: "નવી સ્પ્રાઈટ બનાવો",
    modal_create_project_title: "નવો પ્રોજેક્ટ બનાવો",
    modal_add_sheet_title: "નવી શીટ ઉમેરો",
    modal_rename_sheet_title: "શીટનું નામ બદલો",
    modal_rename_sprite_title: "સ્પ્રાઈટનું નામ બદલો",
    modal_delete_sprite_title: "સ્પ્રાઈટ કાઢી નાખો",
    modal_delete_project_title: "પ્રોજેક્ટ કાઢી નાખો",
    modal_delete_sheet_title: "શીટ કાઢી નાખો",
    placeholder_sprite_name: "નામ",
    placeholder_project_name: "નામ",
    placeholder_sheet_name: "નામ",
    placeholder_new_name: "નવું નામ",
    action_create: "બનાવો",
    action_add: "ઉમેરો",
    action_rename: "નામ બદલો",
    action_duplicate: "ડુપ્લિકેટ",
    action_delete: "કાઢી નાખો",
    action_cancel: "રદ કરો",
    confirm_delete_sprite: "શું તમે ખરેખર આ સ્પ્રાઈટને કાઢી નાખવા માંગો છો?",
    confirm_delete_project: "શું તમે ખરેખર આ પ્રોજેક્ટને કાઢી નાખવા માંગો છો? બધા સ્પ્રાઉટ્સ દૂર કરવામાં આવશે.",
    confirm_delete_sheet: "શું તમે ખરેખર આ શીટ કાઢી નાખવા માંગો છો?",
    err_select_sprite: "કૃપા કરીને પહેલા સ્પ્રાઈટ પસંદ કરો.",
    err_select_project: "કૃપા કરીને પહેલા એક પ્રોજેક્ટ પસંદ કરો.",
    err_name_empty: "નામ ખાલી ન હોઈ શકે.",
    err_sprite_exists: "તે નામ સાથેનો સ્પ્રાઈટ પહેલેથી જ અસ્તિત્વમાં છે.",
    err_project_exists: "તે નામનો પ્રોજેક્ટ પહેલેથી જ અસ્તિત્વમાં છે.",
    err_no_content: "સાચવવા માટે કોઈ સામગ્રી નથી.",
    err_no_changes: "સાચવવા માટે કોઈ ફેરફાર નથી.",
    err_delete_last_sheet: "છેલ્લી શીટ કાઢી શકાતી નથી.",
    err_extract_frames: "કોઈપણ ફ્રેમ્સ કાઢી શકાયા નથી.",
    err_indexeddb: "સ્થાનિક રીતે સાચવવામાં નિષ્ફળ. તમારું બ્રાઉઝર IndexedDB ને સપોર્ટ કરતું નથી.",
    msg_upload_success: "અપલોડ સફળ: {0}",
    msg_upload_failed: "અપલોડ નિષ્ફળ થયું: {0}",
    msg_save_success: "સાચવો સફળ.",
    msg_saving: "સાચવી રહ્યું છે...",
    msg_multi_save_result: "સાચવેલ {0} સંપત્તિ. {1} નિષ્ફળતાઓ.",
    menu_title: "મેનુ",
    menu_save: "સાચવો",
    menu_save_all: "બધા સાચવો",
    menu_support: "સપોર્ટનો સંપર્ક કરો",
    label_local_storage: "સ્થાનિક સંગ્રહ",
    label_sign_in: "સાઇન ઇન કરો",
    modal_export_title: "નિકાસ સ્પ્રાઈટ",
    label_filename: "ફાઇલનામ",
    label_format: "ફોર્મેટ",
    action_export_confirm: "નિકાસ કરો",
};

export default translations;
